import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
//
import Box from "@mui/material/Box";
// component, hooks
import AccordionDetailChildren from "./AccordionDetailChildren";
// store
import { StoreContext } from "../../../../../../store/StoreProvider";
// config,utils
import fireAuth from "../../../../../../api/firebase/auth/utils";

// style

const PersonalTabCtx = () => {
  // props
  // route,intl
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { user } = state;
  // local state
  // hooks
  //
  const isLoggedIn = fireAuth.isLoggedIn(user);

  return <Box>{isLoggedIn && <AccordionDetailChildren />}</Box>;
};

PersonalTabCtx.propTypes = {};

PersonalTabCtx.defaultProps = {};

export default PersonalTabCtx;
